import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Check2 } from 'blaze-ui/icons'
import { ReactComponent as DfyBanner } from 'assets/img/dfy-enterprise.svg'
import Styles from './DfyOffer.module.scss'
import { Modal } from 'almanac-ui/Modal'

interface Props {
  onBack: () => void
  onContinueCancelling: () => void
  onAcceptDfy: () => void
  onClose: () => void
  isLoading: boolean
}

const benefits = [
  'A US-based professional marketer accountable to results',
  'Strategy built around your business and goals',
  'Content created, edited, published, and optimized by a real expert',
  'SEO, social, paid, video, and email — fully managed',
]

export const DfyOffer = ({ onBack, onContinueCancelling, onAcceptDfy, onClose, isLoading }: Props) => {
  return (
    <div className={Styles.container}>
      <Modal.Header title="Keep marketing on autopilot" onClose={onClose} />
      <div className={Styles.content}>
        <Heading level={2} color="var(--dark-90)">
          Hold on — what if we just did your marketing?
        </Heading>
        <div className={Styles.heroBanner}>
          <DfyBanner className={Styles.bannerImage} />
        </div>
        <div className={Styles.benefits}>
          <Heading level={5}>Here's what you get:</Heading>
          <ul className={Styles.benefitsList}>
            {benefits.map((benefit) => (
              <li key={benefit} className={Styles.benefitItem}>
                <span className={Styles.checkIcon}>
                  <Check2 size={14} color="white" />
                </span>
                <Text variant="secondary" color="var(--dark-90)">
                  {benefit}
                </Text>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.footer}>
        <Button className={Styles.backButton} variant="tertiary" size="lg" onPress={onBack} isDisabled={isLoading}>
          Back
        </Button>
        <div className={Styles.buttonGroup}>
          <Button variant="tertiary" size="lg" onPress={onContinueCancelling} isDisabled={isLoading}>
            No Thanks, Continue Cancelling
          </Button>
          <Button variant="primary" size="lg" onPress={onAcceptDfy} isDisabled={isLoading}>
            Book Free Consultation
          </Button>
        </div>
      </div>
    </div>
  )
}
